import React, { useState, useEffect } from "react";
import { InputAdornment, styled } from "@mui/material";
// import SearchIcon from "@material-ui/icons/Search";
import SearchIcon from "@mui/icons-material/Search";
import add from "../../images/add.svg";
import ClipLoader from "react-spinners/ClipLoader";
import { Box, Grid, TextField, Typography, Button } from "@mui/material";
import moment from "moment";
import deleteIcon from "../../images/del.svg";
import DialogComponent from "../reusableComponents/Dialog";
import { useHistory } from "react-router-dom";
import { getFastCashes, removeFastCash } from "./fastCashSlice";
import { useDispatch, useSelector } from "react-redux";
import AddCash from "./AddCash";
import { deleteFashCash } from "./httpCalls";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import { BodyContainer, Header, TopGrid } from "../styles";

const GridBox = styled(Grid)({
  height: "60px",
  backgroundColor: "#FFFFFF",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  padding: "0px 5px",
  marginTop: "5px",
  display: "flex",
  alignItems: "center",
});

function FastCash() {
  const history = useHistory();
  const dispatch = useDispatch();
  const fastCashes = useSelector((state) => state.fastCash.fastCashes);
  const loading = useSelector((state) => state.fastCash.loading);
  const [state, setState] = useState({
    loading: false,
    searchText: "",
    date: "",
    selectedId: "",
    addModal: "",
    deleteModal: "",
    selectedFastCash: "",
    deleteIndex: 0,
  });

  useEffect(() => {
    if (fastCashes == "") {
      dispatch(getFastCashes());
    }
  }, []);

  const deleteToggle = (fastCash, index) => {
    setState((prev) => ({
      ...prev,
      deleteModal: true,
      selectedFastCash: fastCash,
      deleteIndex: index,
    }));
  };

  const deleteCash = () => {
    toggle("deleteModal");
    dispatch(removeFastCash({ index: state.deleteIndex }));
    deleteFashCash(state.selectedFastCash, state.deleteIndex, dispatch);
  };

  const searchedItems = () => {
    if (state.searchText != "") {
      const filtered = fastCashes.filter((item) =>
        item?.name.toLowerCase().includes(state.searchText)
      );
      return filtered;
    } else if (state.date != "") {
      let date = moment(state.date).format("DD-MM-YYYY");
      const filtered = fastCashes.filter((item) => {
        let itemDate = moment(item.date).format("DD-MM-YYYY");
        return itemDate == date;
      });
      return filtered;
    } else {
      return fastCashes;
    }
  };

  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setState((pre) => ({ ...pre, [name]: value }));
  };

  const toggle = (name) => {
    setState((pre) => ({ ...pre, [name]: !pre[name] }));
  };

  const handleDetails = (data) => {
    history.push({
      pathname: "/inventory/admin/fast-cash/details",
      state: { _id: data._id, title: data.name },
    });
  };

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center">
          <Grid item md={3} xs={12}>
            <TextField
              fullWidth
              size="small"
              height="40px"
              label=""
              placeholder="Search by name"
              sx={{
                borderRadius: "4px",
                fontSize: "12px",
                height: "40px",
                lineHeight: "14.06px",
                backgroundColor: "#f9f9f9",
                boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.16)",
                borderBottom: "1px solid #999999 !important",
              }}
              variant="outlined"
              name="searchText"
              value={state.searchText}
              onChange={handleInput}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon className="gray-clr" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid align="center" item lg={5} md={4} xs={12}>
            <Typography variant="h5" sx={{ color: "white" }}>
              Fast Cash
            </Typography>
          </Grid>
          <Grid align="center" item md={3} xs={6}>
            <TextField
              sx={{
                background: "#f9f9f9",
                borderRadius: "4px",
                fontSize: "12px",
              }}
              fullWidth
              variant="outlined"
              size="small"
              type="date"
              name="date"
              onChange={handleInput}
              value={state.date}
            />
          </Grid>
          <Grid item lg={1} md={2} xs={6}>
            <Button
              variant="contained"
              sx={{
                background: "white !important",
                color: "#4EAF50",
                display: "flex",
                justifyContent: "space-evenly",
                ml: "3px",
              }}
              onClick={() => toggle("addModal")}
            >
              <span> Add</span>{" "}
              <img src={add} alt="add" style={{ marginRight: "5px" }} />
            </Button>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer sx={{ mb: "30px" }}>
        {searchedItems() &&
          searchedItems().map((item, index) => {
            return (
              <GridBox key={index} container>
                <Grid item md={4} xs={6}>
                  <Typography
                    variant="h6"
                    style={{
                      color: "#4EAF51",
                      cursor: "pointer",
                      paddingLeft: "3%",
                    }}
                    onClick={() => handleDetails(item)}
                  >
                    {item.name}
                  </Typography>
                </Grid>
                <Grid item md={4} xs={6} sx={{ display: "flex" }}>
                  <Typography style={{ color: "#4EAF51", marginRight: "5px" }}>
                    Total Amount :
                  </Typography>
                  <Typography>{item?.totalAmount}</Typography>
                </Grid>

                <Grid item md={3} xs={11} style={{ display: "flex" }}>
                  <Typography style={{ color: "#4EAF51", marginRight: "5px" }}>
                    Date :
                  </Typography>
                  <Typography>{item?.date}</Typography>
                </Grid>
                <Grid item md={1} xs={1}>
                  <img
                    style={{ cursor: "pointer" }}
                    src={deleteIcon}
                    alt="delete"
                    onClick={() => deleteToggle(item, index)}
                  />
                </Grid>
              </GridBox>
            );
          })}
      </BodyContainer>

      <DialogComponent
        title="Add Cash"
        open={state.addModal}
        onClose={() => toggle("addModal")}
        dialogContent={<AddCash onClose={() => toggle("addModal")} />}
      />
      <DeleteDialog
        title="Delete Fast Cash"
        open={state.deleteModal}
        onClose={() => toggle("deleteModal")}
        onClickYes={deleteCash}
      />

      <Box className="centralize-loader">
        <ClipLoader size={50} color={"#4DAF51"} loading={loading} />
      </Box>
    </Box>
  );
}

export default FastCash;
